import React from "react";

import Logo from "../../assets/images/logo-white.png";
import { layoutPadding } from "./PageLayout";
import { clsxm } from "../../helpers/styling";

export default function Footer(props) {
    return <>
        <footer className={clsxm("mt-auto text-white body-font bg-navbar-gray flex flex-col gap-y-4")}>
            <div className={clsxm(layoutPadding, "flex flex-col")}>
                <div className={clsxm("flex sm:flex-row flex-col gap-y-8 w-full justify-between")}>
                    <div className="flex flex-col gap-y-4 items-center sm:items-start">
                        <div>
                            <img className="" src={Logo} />
                        </div>
                        <p className="whitespace-nowrap text-center sm:text-left">
                            Aroser Allee 76<br />
                            13407 Berlin
                        </p>
                        {/* <p className="flex gap-x-3 text-xl">
                        <a href="#" target="_blank">
                            <i className="fa fa-facebook-square" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank">
                            <i className="fa fa-instagram" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank">
                            <i className="fa fa-twitter" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank">
                            <i className="fa fa-youtube-play" aria-hidden="true"></i>
                        </a>
                    </p> */}
                    </div>
                    <div className="flex flex-col sm:flex-row items-center sm:items-start gap-x-32 gap-y-8">
                        <div className="text-center sm:text-left">
                            <p className="font-bold md:mb-6">Mehr</p>
                            <p><a href="https://www.wunderpen.com/impressum" target="_blank">Impressum</a></p>
                            <p><a href="https://www.wunderpen.com/agb" target="_blank">AGB</a></p>
                            <p><a href="https://www.wunderpen.com/datenschutz" target="_blank">Datenschutz</a></p>
                        </div>
                        <span className="text-center sm:text-left">
                            <p className="font-bold md:mb-6">Kontakt</p>
                            <p><a href="mailto:hello@wunderpen.com">hello@wunderpen.com</a></p>
                            <p>+49 (030) 290 355 03</p>
                        </span>
                    </div>
                </div>
                <p className="w-full text-center text-sm text-white self-end order-last sm:order-none">
                    © Wunderpen GmbH {new Date().getFullYear()}
                </p>
            </div>
        </footer>
    </>;
}